
export default {
  name: 'DrinkGrid',

  props: {
    items: { type: Array, default: () => [] },
    compact: { type: Boolean, default: true },
  },
}
